import { Voni } from '../client';

export interface PromptTemplate {
  id: string;
  name: string;
  category: string;
  description: string;
  prompt: string;
  use_case: string;
  example_questions: string[];
}

export interface PromptTemplatesResponse {
  templates: PromptTemplate[];
  count: number;
}

export interface PromptTestRequest {
  system_prompt: string;
  test_messages: Array<{ role: string; content: string }>;
  temperature?: number;
  max_tokens?: number;
}

export interface PromptTestResponse {
  success: boolean;
  response: string;
  input_tokens: number;
  output_tokens: number;
  cost: number;
  latency_ms: number;
}

export class PromptTemplateResource {
  private client: Voni;

  constructor(client: Voni) {
    this.client = client;
  }

  async list(): Promise<PromptTemplatesResponse> {
    return this.client.request<PromptTemplatesResponse>('GET', '/prompts/templates');
  }

  async get(templateId: string): Promise<PromptTemplate> {
    return this.client.request<PromptTemplate>('GET', `/prompts/templates/${templateId}`);
  }

  async test(data: PromptTestRequest): Promise<PromptTestResponse> {
    return this.client.request<PromptTestResponse>('POST', '/prompts/test', undefined, data);
  }
}
